var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 896"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 265",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "rgba(255, 255, 255, 0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xEF\xBC\x9F",
    d: "M7.07615 9.91588C6.82415 8.03188 9.38015 7.61188 9.38015 6.44788C9.38015 5.71588 8.80415 5.30788 7.85615 5.30788C7.12415 5.30788 6.52415 5.64388 5.93615 6.25588L4.95215 5.35588C5.72015 4.46788 6.77615 3.87988 8.06015 3.87988C9.80015 3.87988 11.0721 4.69588 11.0721 6.29188C11.0721 8.04388 8.44415 8.25988 8.63615 9.91588H7.07615ZM7.86815 13.1199C7.24415 13.1199 6.80015 12.6759 6.80015 12.0519C6.80015 11.4279 7.25615 10.9959 7.86815 10.9959C8.46815 10.9959 8.92415 11.4279 8.92415 12.0519C8.92415 12.6759 8.46815 13.1199 7.86815 13.1199Z",
    fill: "rgba(255, 255, 255, 0.38)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsDark);
export default __webpack_public_path__ + "static/media/tips_dark.5cd907f4e8ce9c9ddfdadf2521e93501.svg";
export { ForwardRef as ReactComponent };